import AppContext from "PFApp/app_context";
import { useContext } from "react";
import { useParams } from "react-router-dom";

type Params = {
  id: string;
};

export const useProfileId = (): number => {
  const {
    store: { currentProfile }
  } = useContext(AppContext);

  const { id } = useParams<Params>();

  return id === "me" ? currentProfile.id : Number(id);
};
